module.exports = __webpack_public_path__ + "img/15.ded80b65.jpg";